import { render, staticRenderFns } from "./ChannelPartnerUsersList.vue?vue&type=template&id=7054b12d"
import script from "./ChannelPartnerUsersList.vue?vue&type=script&lang=js"
export * from "./ChannelPartnerUsersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports